import { defaultErrorMessage } from '../constants/errorMessages';

import CheckLineIcon from '../design-system/Icons/CheckLineIcon';
import ErrorWarningLineIcon from '../design-system/Icons/ErrorWarningLineIcon';

export const COPY_EXCLUDED_ELEMENT_CLASS_NAME = 'copy-excluded-element--x92jfkd9';

export const handleCopyFormattedText = async ({
    node,
    setCopyAlert = () => {},
    successMessage = 'Copied to clipboard!',
}) => {
    if (!node) return;

    try {
        const clonedNode = node.cloneNode(true);

        clonedNode.querySelectorAll(`.${COPY_EXCLUDED_ELEMENT_CLASS_NAME}`).forEach((el) => {
            el.remove();
        });

        clonedNode.querySelectorAll('*').forEach((el) => {
            el.style.backgroundColor = 'transparent';
        });

        const htmlContent = clonedNode.innerHTML;
        let textContent = clonedNode.textContent;
        try {
            textContent = Array.from(clonedNode.children)
                .map((child) => child.textContent.trim())
                .filter((text) => text.length > 0)
                .join('\n');
        } catch (e) {}

        await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([htmlContent], { type: 'text/html' }),
                'text/plain': new Blob([textContent], { type: 'text/plain' }),
            }),
        ]);

        setCopyAlert({
            status: 'positive',
            message: successMessage,
            icon: CheckLineIcon,
        });
    } catch (err) {
        setCopyAlert({
            status: 'critical',
            message: defaultErrorMessage,
            icon: ErrorWarningLineIcon,
        });
    }
};
